module.exports = __webpack_public_path__ + "media/app/images/messages_cta@2x-a74d2acc70604f5ae7c50a6398375742.png";